export default __webpack_public_path__ + "static/media/yahaya.7ec97e48.jpeg";